module.exports = __webpack_public_path__ + "media/images/countrysquared/ls-aa52ea198901198203aec2b15eb75464.svg";